<div class="modal-header">
	<h4 class="modal-title" id="modal-title">Distributed User Load</h4>
	<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.close()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body" id="modal-body">
	<strong>Note :</strong>
	<div class="alert alert-danger" role="alert">User load distribution is relevant for Test Cases where the endpoints in the Test case are not linked with one another.</div>

	<p>The Primary objective of “Distributed User Load” is to define and control the User Load for each End point under same Test case. Let’s see how you can add Distributed User Load.</p>
	<p>Let’s take an example of Hotel Booking application. Each hotel booking website has below mentioned features:</p>

	<ol>
		<li>Hotel Search</li>
		<li>New User Registration</li>
		<li>User Login & Compare Hotels</li>
		<li>User Login & Book Hotel</li>
		<li>Cancel Booking</li>
		<li>Admin Users</li>
	</ol>

	<hr />

	<p>Our requirement is to test above test scenarios with 1000 concurrent users. Now we know that no users who search for hotels are going to complete the booking process. Some of them will just focus on comparing the price and services of hotels. Few of them will go ahead and complete the booking process while there will be some who will cancel the booking. Google Analytics is the best tool to identify the frequency of users visiting pages of application. By thoroughly studying this information we can derive statistics and with the confirmation of concerned person like Product Owner, BA, Project Manager we can identify the load to put on each scenario. This distribution can be something like this:</p>
	<ol>
		<li>Hotel Search (40% User Load)</li>
		<li>New User Registration (10% User Load)</li>
		<li>User Login & Compare Hotels (20% User Load)</li>
		<li>User Login & Book Hotel (20% User Load)</li>
		<li>Cancel Booking (10% User Load)</li>
	</ol>
</div>
